export const GET_REFERRAL_REQUEST = "GET_REFERRAL_REQUEST"
export const GET_REFERRAL_SUCCESS = "GET_REFERRAL_SUCCESS"
export const GET_REFERRAL_FALUIRE = "GET_REFERRAL_FALUIRE"

export const UPDATE_REFERRAL_STATUS_REQUEST = "UPDATE_REFERRAL_STATUS_REQUEST"
export const UPDATE_REFERRAL_STATUS_SUCCESS = "UPDATE_REFERRAL_STATUS_SUCCESS"
export const UPDATE_REFERRAL_STATUS_FALUIRE = "UPDATE_REFERRAL_STATUS_FALUIRE"
